/* @flow */
import OrganizationProfileTeacher from 'entities/OrganizationProfileTeacher';
import Collection from 'lib/Collection';

class OrganizationProfileTeachers extends Collection<OrganizationProfileTeacher> {
  initialize() {
    this.model = OrganizationProfileTeacher;
  }
}

export default OrganizationProfileTeachers;
